import { Pipe, PipeTransform } from '@angular/core';
import ValueGuard from 'app/services/utils/value-guard';

@Pipe({
  name: 'idrCurrency',
})
export class IdrCurrencyPipe implements PipeTransform {
  transform(val: string | number, removeSymbol = false): string {
    if (!ValueGuard.againtsNullOrUndefined(val)) return '';

    let num = 0;
    if (typeof val === 'number') {
      num = val;
    } else {
      let str = val
        .toString()
        .trim()
        .replace(/[^\d.,-]/g, '');
      if (str.includes('.') && str.includes(',')) {
        str = str.replace(/\./g, '').replace(/,/g, '.');
      } else if (str.includes(',')) {
        str = str.replace(/,/g, '.');
      }
      if (str.includes('.')) {
        const parts = str.split('.');
        if (parts.length > 2) {
          str = str.replace(/\./g, '');
        } else if (parts.length === 2) {
          const integerPart = parts[0].replace(/-/g, '');
          const decimalPart = parts[1];
          if (decimalPart.length === 3 && integerPart.length >= 1 && integerPart.length <= 3) {
            str = str.replace(/\./g, '');
          }
        }
      }
      const parsed = parseFloat(str);
      num = isNaN(parsed) ? 0 : parsed;
    }

    const formatterOptions: Intl.NumberFormatOptions = removeSymbol
      ? { style: 'decimal' }
      : { style: 'currency', currency: 'IDR' };

    const formatter = new Intl.NumberFormat('id-ID', formatterOptions);
    let currency = formatter.format(num);

    if (num % 1 === 0) {
      if (currency.endsWith(',00') || currency.endsWith('.00')) {
        currency = currency.slice(0, -3);
      }
    }

    return currency;
  }
}
